import gql from "graphql-tag";

export const ADD_GALLERY_IMAGE = gql`
mutation insert_gallery_image($object: [gallery_insert_input!]!){
  insert_gallery(objects: $object) {
     returning {
      id
  }
 }
}
`

export const UPDATE_GALLERY_IMAGE = gql`
 mutation update_gallery_image($id: uuid!, $object: gallery_set_input) {
 update_gallery (
    where: {id: {_eq: $id}}
    _set: $object
  ) {
    returning {
      id
     }
    }
  }
`
export const DELETE_GALLERY_IMAGE = gql`
mutation delete_gallery_image($id:uuid!){
  delete_gallery(where:{id:{_eq:$id}}){
  returning{id}
  }
}`

export const DELETE_GALLERY = gql`
mutation delete_gallery{
  delete_gallery(where:{id:{_neq:null}}){
  returning{id}
  }
}`
